import { useMemo } from "react"

import { findChildren } from "shared/lib/treeUtils"
import { ProjectChild } from "shared/types/Project"

import { useProject } from "entities/projects/model/useProject"
import { useProjectStore } from "features/project-management/model/useProjectStore"

export function useSelectedProjectChildren({
  projectID
}: {
  projectID: string
}) {
  const { project } = useProject(projectID)
  const { selectedElementIDs } = useProjectStore(projectID)

  return useMemo(
    () => findChildren<ProjectChild>(selectedElementIDs, project?.children),
    [selectedElementIDs, project?.children]
  )
}
